<!-- 카메라 촬영 중 앱이 강제 종료된 뒤 재시작 시 표시되는 안내 모달 (확인 버튼으로만 닫힘) -->
<template>
  <AppUILayoutModal :show="notice !== null" :top-zero="true" :control-parent-click="true">
    <div class="camera-crash-notice">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
          fill="#F59E0B"
        />
      </svg>
      <p class="title">
        <template v-if="notice?.reason === 'restart'"
          >촬영 중 앱이 예기치 않게 종료되었습니다</template
        >
        <template v-else>카메라가 예기치 않게 닫혔습니다</template>
      </p>
      <p class="sub">
        기기의 메모리 부족 또는 카메라 호환 문제일 수 있습니다.<br />
        <template v-if="notice?.reason === 'restart'">
          <template v-if="notice?.photoRecovered">직전에 촬영한 사진은 복구되었습니다.</template>
          <template v-else>
            촬영 중이던 사진은 저장되지 않았을 수 있으니 확인 후 다시 촬영해 주세요.
          </template>
        </template>
      </p>
      <ol class="steps">
        <li>
          증상이 반복되면 <b>기기의 기본 카메라 앱으로 촬영</b>한 뒤, 사진 항목의
          <b>[추가] 버튼</b>으로 첨부해 주세요.
        </li>
        <li>최근 앱 버튼을 눌러 다른 앱을 모두 닫고 다시 시도해 주세요.</li>
        <li>그래도 계속되면 태블릿을 다시 시작해 주세요.</li>
        <li>같은 증상이 계속 반복되면 관리자에게 문의해 주세요.</li>
      </ol>
      <AppUIButton class="primary confirm-btn" size="md" text="확인" @click="close" />
    </div>
  </AppUILayoutModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { cameraCrashNotice } from '@/app/camera'

  const notice = computed(() => cameraCrashNotice.value)

  function close(): void {
    cameraCrashNotice.value = null
  }
</script>

<style lang="scss" scoped>
  .camera-crash-notice {
    display: flex;
    width: 360px;
    max-width: calc(100vw - 40px);
    padding: 30px;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    border-radius: 12px;
    border: 1px solid var(--Gray-300);
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);

    .title {
      font-size: 17px;
      font-weight: 700;
      text-align: center;
      color: #1e293b;
      margin: 0;
    }

    .sub {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #4d5969;
      line-height: 1.5;
      margin: 0;
    }

    .steps {
      width: 100%;
      margin: 0;
      padding: 14px 16px 14px 34px;
      background: #f8fafc;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      li {
        font-size: 13px;
        color: #475569;
        line-height: 1.5;
        word-break: keep-all;

        b {
          color: #1e293b;
        }
      }
    }

    .confirm-btn {
      margin-top: 4px;
      width: 130px;
    }
  }
</style>
